import {BonusBunniesParsedGameData} from "../server/data/BonusBunniesParsedGameData";
import {BonusBunniesBonusSpinsCounterView} from "./BonusBunniesBonusSpinsCounterView";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {BonusBunniesGameModuleConfig} from "../BonusBunniesGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedInitData} from "../server/data/BonusBunniesParsedInitData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";

/**
 * Created by Jerker Nord on 2019-10-25.
 */

export class BonusBunniesBonusSpinsCounterController extends BaseController {

    private _bonusSpinsLeft:number = 3;
    private _previousBonusSpinsLeft:number = 3;
    private _doFillUpMeter:boolean;
    private _view:BonusBunniesBonusSpinsCounterView;
    private _currentMode:string;
    private _nextMode:string;
    private _isRestore:boolean;

    constructor() {
        super();
        this._view = BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView = new BonusBunniesBonusSpinsCounterView();
        this.addFeatureEventHandlers();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.parseFeatureGameData(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, () => this.onSpinStarted());
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._bonusSpinsLeft = data.bonusSpinsRemaining;
        this._isRestore = data.isRestoreState;
        if(data.isRestoreState == true) {
            this._previousBonusSpinsLeft = this._bonusSpinsLeft;
            BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.initCounterNumber = this._bonusSpinsLeft;
            BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.isRestore = true;
        }
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._bonusSpinsLeft = data.bonusSpinsRemaining;
        this._doFillUpMeter = false;
        this._isRestore = false;

        if(data.totalBonusWinMultiplierAfter > data.totalBonusWinMultiplierBefore && data.nextMode == BonusBunniesGameMode.BONUS_GAME) {
            this._doFillUpMeter = true;
        }
    }

    private onSpinStarted():void {
        if((this._bonusSpinsLeft > this._previousBonusSpinsLeft) || this._previousBonusSpinsLeft > 0) {
            this._view.setState(this._previousBonusSpinsLeft);
            if(this._bonusSpinsLeft > this._previousBonusSpinsLeft) {
                //Refill! Do nothing
            } else {
                this._previousBonusSpinsLeft--;
            }
        }
    }

    public playFillUpMeterAnimation():void {
        //Refill meter
        if(this._doFillUpMeter == true) {
            this._doFillUpMeter = false;
            this._view.fillUpMeter(this._previousBonusSpinsLeft);
            this._previousBonusSpinsLeft = 3;
            SlotGame.keypad.setZeroBetSpinCounter(3);
        }
    }

    // Called from Bonus Game intro
    public initBonusSpinsCounter():void {
        //If not restore, make sure meter is filled
        if(this._isRestore == false) {
            this._previousBonusSpinsLeft = 3;
            BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.initCounterNumber = 3;
        }
        this._view.initBonusSpinsCounter();
    }
}